module.exports = __webpack_public_path__ + "media/images/new/topo-map-bg@2x-a3b60fc5d8204ce52ae90dd1955fa737.png";